import React from "react";
import VqqSectionAccordion from "./VqqSectionAccordion";

// Renders every section as an accordion. The sidebar scrolls the user to
// the matching section instead of switching which one is visible.
const VqqSectionView = ({ sections, openSet, onToggle, registerRef }) => {
  if (!sections || sections.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded p-6 text-sm text-gray-500">
        No sections to display.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {sections.map((section) => (
        <VqqSectionAccordion
          key={section.section}
          ref={(node) => registerRef(section.section, node)}
          section={section}
          isOpen={openSet.has(section.section)}
          onToggle={() => onToggle(section.section)}
        />
      ))}
    </div>
  );
};

export default VqqSectionView;
